import { RolesType } from "./types";

export const UserRole = {
  ADMIN: "admin",
  TEACHER: "teacher",
  STUDENT: "student",
} as const;

export const ROLE_LABELS: Record<RolesType, string> = {
  admin: "Администратор",
  teacher: "Учитель",
  student: "Ученик",
};

export const ROLE_COLORS: Record<RolesType, string> = {
  admin: "red",
  teacher: "geekblue",
  student: "green",
};

// Роли, которые администратор может назначить пользователю
export const ASSIGNABLE_ROLES: RolesType[] = [
  UserRole.STUDENT,
  UserRole.TEACHER,
];

// Чем выше в списке, тем приоритетнее роль при отображении
const ROLE_PRIORITY: RolesType[] = [
  UserRole.ADMIN,
  UserRole.TEACHER,
  UserRole.STUDENT,
];

interface WithRoles {
  roles?: RolesType[] | null;
}

// Пользователь без роли считается учеником
export const getUserRole = (user?: WithRoles | null): RolesType =>
  ROLE_PRIORITY.find((role) => user?.roles?.includes(role)) ?? UserRole.STUDENT;

export const hasRole = (user: WithRoles | null | undefined, role: RolesType) =>
  getUserRole(user) === role;

export const isAdmin = (user?: WithRoles | null) =>
  hasRole(user, UserRole.ADMIN);

export const isTeacher = (user?: WithRoles | null) =>
  hasRole(user, UserRole.TEACHER);
